import { requestGet } from '@/common/request';
import { isNumber } from '@/common/utils';
import defaultValue from '@/constants/data-panel-default-data';

// const defualtViewClick = [] // [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]

export default {
  async sourceData(query) {
    // const res = await requestGet('/queryActivityPlan', query)

    // const res = await requestGet('/dataPannel/queryResourceState', query)
    const res = await requestGet('/dataPannel/queryResourceState', query);

    if (res.ret === '0' && res.data) {
      res.data.viewClick.length === 0 && (res.data.viewClick = defaultValue.inSourceData.viewClick);
      res.data.flowEfficiency.length === 0 && (res.data.flowEfficiency = defaultValue.inSourceData.flowEfficiency);
      res.data.dealTrans.length === 0 && (res.data.dealTrans = defaultValue.inSourceData.dealTrans);
      // res.data.viewClick.push(...defualtViewClick.slice(0, defualtViewClick.length - res.data.viewClick.length))
    }

    return await res;
  },
  async sourceLimitTimeData(query) {
    // return await requestGet('/queryResourceStateDetail', query)
    return await requestGet('/dataPannel/queryResourceStateDetail', query);
  },
  async querySourceSite(query) {
    // return await new Promise((resolve, reject) => {
    //   resolve({
    //     ret: '0',
    //     data: {
    //       resourceStates: [
    //         {
    //           resourceStateCode: 125357,
    //           resourceName: '目前我有数据'
    //         }]
    //     }
    //   })
    // })
    return await requestGet('/resourceState/query', query);
  },
  async realScreenData(query) {
    const res = await requestGet('/activityPlanRealTimeCompare', query);

    if (res.ret === '0' && res.data) {
      // 将数据从元格式化成万元
      res.data.saleTarget = convertToWanyuan(res.data.saleTarget);
      res.data.realSale = convertToWanyuan(res.data.realSale);

      if (res.data.yestodaySaleInfo) {
        res.data.yestodaySaleInfo.nativeDealOrderAmount = res.data.yestodaySaleInfo.dealOrderAmount;
        res.data.yestodaySaleInfo.dealOrderAmount = convertToWanyuan(res.data.yestodaySaleInfo.dealOrderAmount);

        (res.data.yestodaySaleInfo.saleDetail || []).forEach((item) => {
          item.saleAmount = convertToWanyuan(item.saleAmount);
        });
      }

      if (res.data.todaySaleInfo) {
        res.data.todaySaleInfo.nativeDealOrderAmount = res.data.todaySaleInfo.dealOrderAmount;
        res.data.todaySaleInfo.dealOrderAmount = convertToWanyuan(res.data.todaySaleInfo.dealOrderAmount);

        (res.data.todaySaleInfo.saleDetail || []).forEach((item) => {
          item.saleAmount = convertToWanyuan(item.saleAmount);
        });
      }
    }

    return res;

    function convertToWanyuan(val) {
      return isNumber(val) ? val / 10000 : val;
    }
  },
  async visibleActivityList(query) {
    return await requestGet('/data/visibleActivityList', query);
  },
};
